import { Typography } from "@mui/material";
import React, { useContext, useEffect } from "react";
import { useParams } from "react-router";
import { retrieveInvitedEmail, verifyRegistrationKey } from "../services/RegistrationService";
import { Context } from "../states/Store";
import { primary, secondary, theme } from "../style/globalStyle";
import RegistrationContainer from "../components/common/RegistrationContainer";
import i18next from "i18next";
import 'react-phone-input-2/lib/style.css';
import { Trans } from "react-i18next";
import { useQuery } from "../config/Config";
import { APPS } from "../services/Constantes";
import RegistrationNotFoundBlock from "./RegistrationNotFoundBlock";
import {useStyles} from "../style/completeStyle";
import ErrorUnknownBlock from "./ErrorUnknownBlock";
import RegistrationFormBlock from "./RegistrationFormBlock";
import RegistrationFormBlockAprovall from "./RegistrationFormBlockAprovall";
import SirenVerificationBlock from "./SirenVerificationBlock";

function Complete() {
  const classes = useStyles();
  const [errorComplete, setErrorComplete] = React.useState(null);
  const [, dispatch] = useContext(Context);
  const [found, setFound] = React.useState(false);
  const app = useQuery().get("app");
  const [registrationTheme, setRegistrationTheme] = React.useState(APPS.includes(app?.toLowerCase()) ? app?.toLowerCase() : "do");
  const [isUserRegistered, setIsUserRegistered] = React.useState(false);
  const [email, setEmail] = React.useState("");
  const [appUrl, setAppUrl] = React.useState();
  // CAS 1 : vérification préalable du SIREN (premier utilisateur d'un CPTFO vide)
  const [sirenRequired, setSirenRequired] = React.useState(false);
  const [sirenVerified, setSirenVerified] = React.useState(false);
  const [verifiedSiren, setVerifiedSiren] = React.useState(null);
  // Noms affichés dans l'écran de vérification SIREN (fournis par le backend, à câbler)
  const [clientName, setClientName] = React.useState("");
  const [establishmentName, setEstablishmentName] = React.useState("");
  let { registrationKey } = useParams();

  useEffect(() => {
    let link = document.querySelector("link[rel~='icon']");
    if (registrationTheme === 'fo') {
      theme.palette.primary.main = secondary
      theme.palette.secondary.main = primary
      link.href = process.env.PUBLIC_URL + "/favicon_fo.ico";
    } else {
      theme.palette.primary.main = primary
      theme.palette.secondary.main = secondary
      link.href = process.env.PUBLIC_URL + "/favicon_do.ico";
    }
    let title = document.querySelector("title");
    if (registrationTheme === '365') {
      title.textContent = "Aprovall 360";
    } if (registrationTheme === "portal"){
      title.textContent = "Aprovall"
    }else {
      title.textContent = "e-Attestations";
    }

    dispatch({ type: "REGISTRATION_THEME", theme: registrationTheme });
  }, [dispatch, registrationTheme])

  useEffect(() => {
    (async () => {
      try {
        const verificationResp = await verifyRegistrationKey(registrationKey);
        if (verificationResp.httpStatus !== "NOT_FOUND") {
          setRegistrationTheme(APPS.includes(app?.toLowerCase()) ? app?.toLowerCase() : verificationResp.body?.registrationTheme);
          setIsUserRegistered(verificationResp.body?.registered);
          setSirenRequired(verificationResp.body?.sirenVerificationRequired === true);
          setClientName(verificationResp.body?.clientName || "");
          setEstablishmentName(verificationResp.body?.establishmentName || "");
          const invitedEmailResponse = await retrieveInvitedEmail(registrationKey)
          if (invitedEmailResponse.httpStatus === "OK") {
            setEmail(invitedEmailResponse.body)
            setFound(true);
          } else {
            setFound(false);
          }

        } else {
          setFound(false);
        }
        setAppUrl(verificationResp.body?.redirectionUrl);
        dispatch({ type: "LOADER", loader: false });
      } catch (e) {
        if (e?.message?.status === 404) {
          setFound(false);
        }
        setErrorComplete(<ErrorUnknownBlock app={registrationTheme}></ErrorUnknownBlock>);
        dispatch({ type: "LOADER", loader: false });
      }
    })();
  }, [dispatch, registrationKey, app, registrationTheme]);

  const getErrorType = () => {
    return (!found && errorComplete)
        ? "unknownError"
        : (!found && appUrl)
            ? "invalidRegistration"
            : (!found && !appUrl && !errorComplete)
                ? "registrationNotFound"
                : (found && isUserRegistered)
                    ? "userAlreadyRegistered"
                    : null
  }

  // Rendu spécifique à 365 et portal
  if (app === "365" || app === "portal") {

    return (
      <RegistrationContainer
        app={app}
        errorType={getErrorType()}
        appUrl={appUrl}
        registrationTheme={registrationTheme}
      >
        {found && !isUserRegistered && sirenRequired && !sirenVerified && (
          <SirenVerificationBlock
            registrationTheme={registrationTheme}
            clientName={clientName}
            establishmentName={establishmentName}
            onVerified={(siren) => {
              setVerifiedSiren(siren);
              setSirenVerified(true);
            }}
          />
        )}

        {found && !isUserRegistered && (!sirenRequired || sirenVerified) && (
          <RegistrationFormBlockAprovall
            email={email}
            registrationTheme={registrationTheme}
            app={app}
            verifiedSiren={verifiedSiren}
          />
        )}
      </RegistrationContainer>
    )
  }

  return (
    <RegistrationContainer>
      {!found && errorComplete && (
        <ErrorUnknownBlock app={registrationTheme}></ErrorUnknownBlock>
      )}
      {!found && appUrl && (
        <Typography className={classes.invalidRegistration}>
          {i18next.t('invalidRegistration1')}<br /><br />
          {i18next.t('invalidRegistration2')}<br /><br />
          {i18next.t('invalidRegistration3')} <a href={appUrl}>{i18next.t('here')}</a>.
        </Typography>
      )}

      {!found && !appUrl && !errorComplete && (
        <Typography className={classes.invalidRegistration}>
          {<RegistrationNotFoundBlock app={registrationTheme}></RegistrationNotFoundBlock>}
        </Typography>
      )}

      {found && isUserRegistered && (
        <Typography className={classes.invalidRegistration}>
          <Trans i18nKey="userAlreadyRegistered" appUrl={appUrl}>
            {i18next.t('userAlreadyRegistered1')}<br /><br />
            {i18next.t('userAlreadyRegistered2')} <a href={appUrl}>{i18next.t('clickHere')}</a>.
          </Trans>
        </Typography>
      )}

      {found && !isUserRegistered && (
        <RegistrationFormBlock
          email={email}
          registrationTheme={registrationTheme}
        />
      )}
    </RegistrationContainer>
  );
}

export default Complete;
